import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import MenuIcon from '@mui/icons-material/Menu'
import PersonIcon from '@mui/icons-material/Person'
import PhoneIcon from '@mui/icons-material/Phone'
import YoutubeIcon from '@mui/icons-material/YouTube'
import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@mui/material'
import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import * as React from 'react'
import { useCallback, useContext, useEffect } from 'react'
import { Link as NavLink, useLocation, useNavigate } from 'react-router-dom'
import { ApplicationContext, FirebaseContext } from '../../Contexts'
import logoImage from '../../assets/logo.webp'
import manOfficeImage from '../../assets/man-working-office.webp'

const pages = [{ title: 'Home', path: '/' }, { title: '¿Quienes somos?', path: '/qienes-somos' }, { title: 'Contacto', path: '/contacto' }]

const LinkEffects = {
  opacity: '.75',
  transition: '.3s',
  fontWeight: 500,
  color: '#1b3458',
  ':hover': {
    color: '#89161a',
  },
}

export const Header = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null)
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null)
  const { auth, candidateCollection } = useContext(FirebaseContext)
  const { user, setUser } = useContext(ApplicationContext)
  const navigate = useNavigate()
  const location = useLocation()

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const checkSession = useCallback(async () => {
    await auth.authStateReady()

    if (!auth?.currentUser) return 

    const document = doc(candidateCollection, auth.currentUser.uid)
    const data = (await getDoc(document)).data()

    if (setUser) {
      if (data) return setUser(data)

      setUser({
        id: auth.currentUser.uid,
        personalData: {
          name: auth.currentUser.displayName?.split(' ').shift() || '',
          surname: auth.currentUser.displayName?.split(' ').slice(1).join(' ') || '',
          email: auth.currentUser.email || '',
        } as any,
        ...(auth.currentUser.photoURL ? { photo: { url: auth.currentUser.photoURL } } : {}),
      } as any)
    }
  }, [auth, candidateCollection, setUser])

  const login = useCallback(async () => {
    await auth.authStateReady()

    if (auth.currentUser) return checkSession()

    signInWithPopup(auth, new GoogleAuthProvider())
      .then(async (result) => {
        const document = doc(candidateCollection, result.user.uid)
        const data = (await getDoc(document)).data()

        if (data && setUser) setUser(data)
      })
      .catch((error) => {
        const credential = GoogleAuthProvider.credentialFromError(error)

        console.log(error)
        console.log(credential)

        alert(`Erro: ${error.message}`)
      })
  }, [auth, setUser, candidateCollection, checkSession])
  const logout = () => {
    signOut(auth)
    if (setUser) setUser(undefined)
  }

  useEffect(() => {
    if (!user) checkSession()
  }, [user, checkSession])

  return (
    <Box sx={{ position: 'relative', height: 'auto', minHeight: { xs: 50, md: 220 } }}>
      <Box
        className="banner-top"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          minHeight: { xs: 50, md: 220 },
          width: `100%`,
        }}
      >
        <Box
          component='img'
          src={manOfficeImage}
          alt="cover"
          sx={{
            width: '100%',
            height: '100%',
            minHeight: { xs: 50, md: 220 },
            objectFit: 'cover',
            objectPosition: 'bottom center',
            opacity: 0.4,
            filter: 'grayscale(100%) brightness(.2)',
          }}
        />
      </Box>
     
      {/* - */}

      <Container maxWidth="xl" sx={{ display: { xs: 'block', md: 'none' } }}>
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page.title} onClick={() => { handleCloseNavMenu(); navigate(page.path) }}>
                  <Typography textAlign="center">{page.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, mr: 1 }}>
            <img src={logoImage} alt="logo" style={{ height: 40 }} />
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Button
              size="small"
              startIcon={<PersonIcon />}
              sx={{
                ...LinkEffects,
                fontSize: '1rem',
                letterSpacing: '.5px',
                textTransform: 'uppercase',
                display: auth.currentUser ? 'none' : 'flex',
              }}
              onClick={() => login()}
            >
              Login
            </Button>

            <Box display={auth.currentUser ? 'flex' : 'none'}>
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0, m: 0, mt: -0.5 }}>
                <Avatar
                  sx={{ bgcolor: '#1b3458' }}
                  alt={auth.currentUser?.displayName || ''}
                >
                  {auth.currentUser?.displayName?.charAt(0)}
                </Avatar>
              </IconButton>
              <Menu
                sx={{ mt: '24px' }}
                id="menu-appbar-xs"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem
                  onClick={() => {
                    handleCloseUserMenu()
                    navigate('/mi-cv')
                  }}
                >
                  <Typography textAlign="center">Mi CV</Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleCloseUserMenu()
                    logout()
                  }}
                >
                  <Typography textAlign="center">Salir</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </Container>

      {/* - */}

      <Container sx={{ position: 'relative', textAlign: 'left', paddingTop: 2, display: { xs: 'none', md: 'flex' } }}>
        <Grid container>
          <Grid item xs={12} md={2} textAlign="center">
            <Grid item xs={12}>
              <img src={logoImage} alt="RH Empresa & Personas" />
              <Typography
                textAlign="center"
                sx={{
                  fontSize: 10,
                }}
              >
                RH EMPRESA &
              </Typography>
              <Typography
                textAlign="center"
                sx={{
                  fontSize: 14,
                  color: '#89161a',
                }}
              >
                Personas
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} md={10}>
            <Grid
              container
              spacing={2}
              direction="row-reverse"
              justifyContent="flex-start"
              alignItems="center"
              sx={{
                borderBottom: '1px solid rgba(240,240,240,0.25)',
              }}
            >
              <Grid item>
                <Button
                  size="small"
                  startIcon={<PersonIcon />}
                  sx={{
                    ...LinkEffects,
                    fontSize: '1rem',
                    letterSpacing: '.5px',
                    textTransform: 'uppercase',
                    display: auth.currentUser ? 'none' : 'flex',
                  }}
                  onClick={() => login()}
                >
                  Login
                </Button>

                <Box display={auth.currentUser ? 'flex' : 'none'}>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0, m: 0, mt: -0.5 }}>
                    <Avatar
                      sx={{ bgcolor: '#1b3458', width: 24, height: 24, fontSize: 12 }}
                      alt={auth.currentUser?.displayName || ''}
                    >
                      {auth.currentUser?.displayName?.charAt(0)}
                    </Avatar>
                  </IconButton>
                  <Menu
                    sx={{ mt: '24px' }}
                    id="menu-appbar-md"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                  >
                    <MenuItem
                      onClick={() => {
                        handleCloseUserMenu()
                        navigate('/mi-cv')
                      }}
                    >
                      <Typography textAlign="center">Mi CV</Typography>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleCloseUserMenu()
                        logout()
                      }}
                    >
                      <Typography textAlign="center">Salir</Typography>
                    </MenuItem>
                  </Menu>
                </Box>
              </Grid>
              <Grid item>
                <Typography textAlign="center">-</Typography>
              </Grid>
              <Grid item>
                <Link href="#">
                  <InstagramIcon fontSize="medium" sx={LinkEffects} />
                </Link>
              </Grid>
              <Grid item>
                <Link href="#">
                  <FacebookIcon fontSize="medium" sx={LinkEffects} />
                </Link>
              </Grid>
              <Grid item>
                <Link href="#">
                  <YoutubeIcon fontSize="medium" sx={LinkEffects} />
                </Link>
              </Grid>
              <Grid item>
                <Button
                  size="small"
                  startIcon={<PhoneIcon sx={{ color: '#89161a' }} />}
                  sx={{ ...LinkEffects, fontSize: '0.8rem', letterSpacing: '.5px', textTransform: 'uppercase' }}
                >
                  (xxx) xxx xxx
                </Button>
              </Grid>
              <Grid item flex={1}>
                <Grid container spacing={2} direction="row" justifyContent="flex-start" alignItems="center">
                  {pages.map((page, index) => (
                    <Grid item key={index}>
                      <NavLink
                        to={page.path}
                        style={{
                          ...LinkEffects,
                          color: 'white',
                          textTransform: 'uppercase',
                          fontSize: 12,
                          textDecoration: 'none',
                        }}
                      >
                        {page.title}
                      </NavLink>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Typography variant="h4" sx={{ color: 'white' }}>
              {
                [
                  {
                    pathname: '/',
                    title: 'Crie su CV',
                  },
                  {
                    pathname: '/mi-cv',
                    title: 'Mi CV',
                  },
                ].find((path) => path.pathname === location.pathname)?.title
              }
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default Header
